import React, {useEffect, useRef, useState} from 'react';
import {IconClose} from '@arco-design/web-react/icon';
import {MacauLivePlayer} from './MacauLivePlayer';

const LIVE_URL = 'https://video.api-macaujc.com/macau/';
export function MacauLiveDialog({onClose}) {
  const dialog = useRef(null);
  const [reload, setReload] = useState(0);
  const [line, setLine] = useState(0);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const previous = document.activeElement;
    const overflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    dialog.current.showModal();
    return () => { document.body.style.overflow = overflow; previous?.focus(); };
  }, []);
  return <dialog ref={dialog} className="peek-dialog macau-live-dialog" aria-labelledby="macau-live-title" onCancel={event => {event.preventDefault(); onClose();}}>
    <div className="section-heading"><div><h2 id="macau-live-title">新澳门六合彩 · 直播</h2></div><button type="button" aria-label="关闭直播" onClick={onClose}><IconClose/></button></div>
    <div className="macau-live-lines" role="group" aria-label="直播线路"><span>直播线路切换：</span>{['线路一', '线路二', '线路三', '动画直播'].map((label, index) => <button key={label} type="button" aria-pressed={line === index} onClick={() => {setLine(index); setLoading(true);}}>{label}</button>)}</div>
    {line === 3 ? <>{loading && <p role="status" className="muted">正在加载直播页面…</p>}
    <iframe key={reload} className="macau-live-frame" src={LIVE_URL} title="新澳门六合彩动画直播" sandbox="allow-scripts allow-same-origin" allow="autoplay; fullscreen" allowFullScreen referrerPolicy="no-referrer" onLoad={() => setLoading(false)}/></> : <MacauLivePlayer key={`${line}:${reload}`} line={line}/> }
    <div className="macau-live-footer"><p className="muted">无画面时请尝试重新加载。</p><button type="button" onClick={() => {setLoading(true); setReload(value => value + 1);}}>重新加载</button></div>
  </dialog>;
}
